module.exports = __webpack_public_path__ + "img/4.2711fc46.jpg";